'use client';

import { useTheme } from 'next-themes';
import { DriftTheme } from '../environmentVariables/EnvironmentVariables';

const useDriftTheme = () => {
	const themeSetting = useTheme().theme as DriftTheme;

	return themeSetting;
};

export default useDriftTheme;
